'use strict';

var teamsCtrl = ['Authentication', '$http', '$stateParams', 'Department', '$state', '$translate', 'dialog', '$uibModal', function(Authentication, $http, $stateParams, Department, $state, $translate, dialog, $uibModal) {
    var _this = this;
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");

    this.editTeam = function(team) {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', '$stateParams', 'Department', function($uibModalInstance, $stateParams, Department) {
                var modal = this;
                modal.team = {
                    name: team.name
                };

                modal.save = function() {
                    if (!modal.team.name || !modal.team.name.trim()) {
                        return;
                    }

                    modal.loading = true;
                    Department.teams.updateById({
                            id: $stateParams.departmentId,
                            fk: team.id
                        }, {
                            name: modal.team.name.trim()
                        })
                        .$promise
                        .then(function(updatedTeam) {
                            $uibModalInstance.close(updatedTeam);
                        })
                        .catch(function(error) {
                            console.log(error);
                            modal.loading = false;
                        });
                };
            }],
            templateUrl: 'dashboard-teams/dashboardEditTeamModal.html',
            controllerAs: 'modal',
            size: 'sm',
            windowClass: 'dialog',
            bindToController: true
        }).result.then(function(updatedTeam) {
            team.name = updatedTeam.name || team.name;
        });
    };

    this.deleteTeam = function(team) {
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_TEAMS.DIAG_DEL.TITLE'),
            body: $translate.instant('DASHBOARD.DASH_TEAMS.DIAG_DEL.BODY'),
            accept: $translate.instant('DASHBOARD.DASH_TEAMS.DIAG_DEL.ACCEPT'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(function() {
            Department.teams.destroyById({
                    id: $stateParams.departmentId,
                    fk: team.id
                })
                .$promise
                .then(function() {
                    _this.teams = _this.teams.filter(function(currentTeam) {
                        return team.id !== currentTeam.id;
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        });
    };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            teams: '='
        },
        controller: teamsCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-teams/dashboardTeamsDirective.html'
    };
};
